module.exports = __webpack_public_path__ + "static/skill-factory-2-318a10f7868407a20b4a85fc470d0575.svg";